import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCasino = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.25 12.75H13.75C13.2 12.75 12.75 13.2 12.75 13.75V22.25C12.75 22.8 13.2 23.25 13.75 23.25H22.25C22.8 23.25 23.25 22.8 23.25 22.25V13.75C23.25 13.2 22.8 12.75 22.25 12.75Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75002 19.11L6.87002 20.16C6.09002 20.44 5.23002 20.04 4.95002 19.26L0.840018 7.99002C0.560018 7.21002 0.960018 6.35002 1.74002 6.07002L5.20002 4.77002",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.75 9.81V2.25C18.75 1.42 18.08 0.75 17.25 0.75H9.75C8.92 0.75 8.25 1.42 8.25 2.25V14.25C8.25 15.08 8.92 15.75 9.75 15.75H9.79",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.12 20.25C15.91 20.25 15.74 20.08 15.74 19.87C15.74 19.66 15.91 19.49 16.12 19.49",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.12 20.25C16.33 20.25 16.5 20.08 16.5 19.87C16.5 19.66 16.33 19.49 16.12 19.49",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.87 16.5C19.66 16.5 19.49 16.33 19.49 16.12C19.49 15.91 19.66 15.74 19.87 15.74",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.87 16.5C20.08 16.5 20.25 16.33 20.25 16.12C20.25 15.91 20.08 15.74 19.87 15.74",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 7.08L13.5 9.8L11.5 7.08L13.5 4.37L15.5 7.08Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.42004 8.92998C4.21004 8.92998 4.04004 8.75998 4.04004 8.54998C4.04004 8.33998 4.21004 8.16998 4.42004 8.16998",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.42004 8.92998C4.63004 8.92998 4.80004 8.75998 4.80004 8.54998C4.80004 8.33998 4.63004 8.16998 4.42004 8.16998",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export { SvgCasino as ReactComponent };
